import { Link } from 'react-router-dom';
import { categories } from '@/mocks/articles';

export default function CategoryNav() {
  return (
    <section className="w-full px-4 md:px-6 py-8 md:py-10">
      <div className="grid grid-cols-3 sm:grid-cols-6 gap-3">
        {categories.map((cat) => (
          <Link
            key={cat.slug}
            to={`/category/${cat.slug}`}
            className="group flex flex-col items-center gap-2.5 p-4 rounded-xl bg-background-50 border border-background-200/70 hover:border-primary-300 hover:bg-primary-50/30 transition-all duration-300"
          >
            <div className="w-12 h-12 flex items-center justify-center rounded-full bg-primary-100 group-hover:bg-primary-500 transition-colors duration-300">
              <i className={`${cat.icon} text-xl text-primary-600 group-hover:text-background-50 transition-colors duration-300 w-5 h-5 flex items-center justify-center`}></i>
            </div>
            <span className="text-sm font-medium text-foreground-700 group-hover:text-primary-600 transition-colors whitespace-nowrap">
              {cat.name}
            </span>
          </Link>
        ))}
      </div>
    </section>
  );
}